// This file was automatically generated from ext.onboarding.notDoctorDialog.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ext.onboarding.notDoctorDialog');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ext.onboarding.notDoctorDialog.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8PromptDialogContainer"><h1 class="el8PageTitle">Thanks for Your Interest</h1><p>Due to our current online verification processes, only MD\'s or DO\'s may complete the sign up process online. In the interim, feel free to:</p><ol class="spacer"><li class="el8BulletText">Contact Elation for an online demo by either emailing <a href="mailto:questions@elationhealth.com">questions@elationhealth.com</a> or calling 888.974.5625.</li><li class="el8BulletText">Test drive <a target="_blank" rel="noopener" href="https://www.explore.elationemr.com/">our interactive demo</a>.</li><li class="el8BulletText">Ask a physician from your practice to create a free test account.</li></ol></div>');
  if (!opt_sb) return output.toString();
};
